<template>
  <ModalDialog class="ProductDialog" ref="dialog">
    <h4 class="title">{{ content.title }}</h4>
    <ProductResourceGroup v-if="content.primaryResourceGroup"
      :content="content.primaryResourceGroup"
      :product="content.slug"
      class="primaryGroup"
    />
    <div class="otherGroups" v-if="content.otherResourceGroups">
      <ProductResourceGroup v-for="resource in content.otherResourceGroups"
        :key="resource._id"
        :content="resource"
        :product="content.slug"
      />
    </div>
  </ModalDialog>
</template>

<script>
import ModalDialog from '../shared/ModalDialog.vue'
import ProductResourceGroup from './ProductResourceGroup.vue'

export default {
  components: {
    ModalDialog,
    ProductResourceGroup,
  },
  props: {
    content: {
      type: Object,
      default: Object,
    },
  },
  methods: {
    showModal() {
      this.$refs.dialog.showModal()
    },
  },
}
</script>

<style scoped>

.title {
  color: var(--text-color-black);
  font-weight: 600;
  font-size: var(--font-size-8);
}

.title + .primaryGroup,
.title + .otherGroups {
  margin-top: var(--spacing-8);
}

.primaryGroup + .otherGroups {
  margin-top: var(--spacing-9);
  border-top: thin solid var(--hairline-color);
  padding-top: var(--spacing-9);
}

.otherGroups {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-13) var(--spacing-3);
}

@media (--screen-lg) {

  .otherGroups {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
